<template>
  <div class="channel-class-item-container"
       @click="toPlayPage"
       :class="{play: index === curIndex}">
    <div class="left"
         @click="togglePlay">
      <img v-lazy="item.cover_large || item.cover" />
      <div class="icon-container"
           :class="{'audio-icon': item.type === 'audio'}">
        <img :class="item | getIconClass"
             :src="item | iconSrc(index, curIndex)"
          />
      </div>
      <div v-if="hasBought && item.is_lock"
           class="popup-lock">
        <img class="lock"
             src="../../assets/icons/lock.png"
             alt="">
      </div>
    </div>
    <div class="right">
      <div class="title-box">
        <div class="title"
             :style="{'max-width': item.is_try?'9.95rem':'12.24rem'}">{{item.title}}
        </div>
        <span class="try-look"
              v-if="item.is_try">{{item.type === 'audio' ? '试听' : '试看'}}</span>
      </div>
      <div class="detail">
        <div class="account">
          <div class="wrapper">
            <img class="iconfonts"
                 v-if="item.type === 'audio' || item.type === 'video'"
                 src="../../assets/icons/play_count.png"
                 alt="">
            <img class="iconfonts"
                 v-else
                 src="../../assets/icons/read.png"
                 alt="">
            <span>{{playcount || 0}}</span>
          </div>
          <div class="wrapper">
            <img class="iconfonts"
                 src="../../assets/icons/comment_acount.png"
                 alt="">
            <span>{{item.comment_count || 0}}</span>
          </div>
          <div class="wrapper"
               v-if="item.type === 'audio' && index === curIndex">{{rate}}%</div>
        </div>
        <div class="rule"
              v-if="!isXcxWeb"
             @click.stop="toApp">
          <img src="../../assets/icons/download_grey.png"
               class="download" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import openApp from '@ivy/fts/openApp'
import { isXcxWeb } from '@ivy/fts/utils'
export default {
  props: ["item", "index", "curIndex", "rate", "hasBought"],
  isXcxWeb: isXcxWeb(),
  mounted() {
    console.log(this.item)
  },
  filters: {
    getIconClass(item) {
      return `${item.type}_icon`
    },
    iconSrc(item, index, curIndex) {
      let type = item.type
      if (type === 'audio') {
        type = +index === +curIndex ? 'audio_pause' : 'audio_play'
      }

      return {
        audio_play: require('../../assets/icons/player.png'),
        audio_pause: require('../../assets/icons/pause.png'),
        video: require('../../assets/icons/videoplayer.png'),
        text: require('../../assets/icons/text.png'),
        game: require('../../assets/icons/text.png'),
      }[type]
    }
  },
  computed: {
    playcount() {
      let f = this.item.play_count > 9999
      return f ? `${(this.item.play_count / 10000).toFixed(1)}万` : this.item.play_count
    }
  },
  methods: {
    toApp() {
      openApp('readtool')
    },
    toPlayPage() {
      this.$emit("toPlayPage", this.item)
    },
    playAudio() {
      this.$emit("playAudio", this.index)
    },
    pauseAudio() {
      this.$emit("pauseAudio")
    },
    getTime(ptime, ctime) {
      if (ptime === '00-00' || ptime === null) return ctime
      return ptime
    },
    togglePlay(e) {
      if (this.item.type !== 'audio' || +this.item.is_lock !== 0) return
      if (this.index === this.curIndex) {
        this.pauseAudio()
      } else {
        this.playAudio()
      }
      e.stopPropagation()
    }
  }
}
</script>
<style lang="less" scoped>
@import url("../../common.less");
@normalSize: 3.53rem;
@media only screen and (max-width: 320px) {
  @normalSize: 4rem;
}
.rule {
  font-size: 0.88rem;
  img {
    width: 1.29rem;
    height: 1.29rem;
  }
}
.channel-class-item-container {
  margin-bottom: 1.06rem;
  .display-flex;
  height: @normalSize;
  .left {
    position: relative;
    margin-right: 0.29rem;
    width: @normalSize;
    height: @normalSize;
    .display-flex;
    border-radius: 0.53rem;
    overflow: hidden;
    flex: none;
    justify-content: flex-start;
    &::before {
      display: block;
      content: "";
      width: 100%;
      height: 1.76rem;
      position: absolute;
      left: 0;
      bottom: 0;
      background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.3) 0%,
        rgba(255, 255, 255, 0) 100%
      );
    }
    img {
      height: @normalSize;
      border-radius: 0.53rem;
    }
    .icon-container {
      position: absolute;
      bottom: 0.29rem;
      left: 0.29rem;
      width: 1.06rem;
      height: 0.82rem;
      .display-flex;
      &.audio-icon {
        left: auto;
        right: 0.29rem;
        height: 1.06rem;
        width: 1.06rem;
      }
      img {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border-radius: 0;
      }
    }
    .popup-lock {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.3);
      .display-flex;
      .lock {
        width: @normalSize / 4;
        height: auto;
      }
    }
  }
  .right {
    margin-left: 0.68rem;
    height: @normalSize;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title-box {
      display: flex;
      align-items: center;
    }
    .title {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 0.88rem;
    }
    .try-look {
      margin-left: 0.53rem;
      border: 0.03rem solid @commonColor;
      border-radius: 0.18rem;
      width: 2.06rem;
      height: 1rem;
      font-size: 0.59rem;
      text-align: center;
      line-height: 1rem;
      color: @commonColor;
      vertical-align: middle;
    }
    .detail {
      width: 100%;
      .display-flex;
      justify-content: space-between;
      font-size: 0.71rem;
      color: @text3;
      .account {
        flex: 1;
        .display-flex;
        justify-content: flex-start;
        height: 1.18rem;
        .iconfonts {
          display: block;
          width: 0.71rem;
          height: 0.71rem;
        }
        .wrapper {
          width: 3.53rem;
          font-size: 0.71rem;
          font-weight: normal;
          line-height: 0.71rem;
          display: flex;
          .homework-wrapper {
            .display-flex;
          }
          span {
            margin-left: 0.18rem;
          }
        }
      }
    }
  }
  &.play {
    color: @commonColor !important;
    .right {
      color: @commonColor !important;
      .detail {
        color: @commonColor !important;
      }
    }
  }
}
</style>
